export const layoutClasses= [
    { Defaul:'compact-wrapper' },
    { Compact:'compact-wrapper compact-sidebar' },
    { Modern:'compact-wrapper modern-sidebar' },
    { Horizontal:'horizontal-wrapper enterprice-type' },
];